export default __webpack_public_path__ + "static/media/speaking-icon.65610eac.svg";